import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { OPERATIONS_ON_HOLD_CANCELED_SERIES } from "../constants";
import { OperationsMetricChartWidget } from "../OperationsMetricChartWidget";
import type { OperationsOnHoldCanceledChartData } from "../types";

interface OperationsOnHoldCanceledWidgetProps {
  chart: OperationsOnHoldCanceledChartData;
  yAxisMax?: number;
  onExport?: (format: "csv" | "xlsx") => void;
  exportDisabled?: boolean;
  className?: string;
}

export const OperationsOnHoldCanceledWidget: React.FC<
  OperationsOnHoldCanceledWidgetProps
> = ({ chart, yAxisMax, onExport, exportDisabled, className }) => {
  const { t } = useTranslation();

  const series = useMemo(
    () =>
      OPERATIONS_ON_HOLD_CANCELED_SERIES.map((item) => ({
        ...item,
        label: t(
          `analytics.operations.onHoldCanceled.series.${item.key}`,
          item.label,
        ),
      })),
    [t],
  );

  return (
    <OperationsMetricChartWidget
      title={t(
        "analytics.operations.onHoldCanceled",
        "On hold and canceled requests",
      )}
      data={chart.data}
      series={series}
      stacked={false}
      yAxisMax={yAxisMax}
      onExport={onExport}
      exportDisabled={exportDisabled}
      className={className}
    />
  );
};
